import React, { useEffect } from "react";
import logo from "../Assets/Netflix_Logo_PMS.png";
import usImg from "../Assets/Netflix-avatar.png";
import { signOut } from "firebase/auth";
import { auth } from "../utils/Firebase";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { onAuthStateChanged } from "firebase/auth";
import { addUser, removeUser } from "../utils/UserSclice";
import { toggleGptSerchView } from "../utils/gptSlice";
import { changelanguage} from "../utils/configSlice";
import { SUPPORTED_LANG } from "../utils/Constants";
import {  addGptMovieResult } from "../utils/gptSlice";

const Header = () => {
  const navigate = useNavigate();
  const user = useSelector((store) => store.user);
  const showGptSearch  = useSelector((store)=> store.gpt.showGptSearch)
  const showDetails = useSelector((store)=> store.details.showDetails);
  const dispatch = useDispatch();
  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        navigate("/error");
      });
  };
  useEffect(() => {
   const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid, email, displayName, photoURL } = user;
        dispatch(
          addUser({
            uid: uid,
            email: email,
            displayName: displayName,
            photoURL: photoURL,
          })
        );
        navigate("/browse");
      } else {
        dispatch(removeUser());
        navigate("/");
      }
    });

    return () => unsubscribe();
  }, []);

  const handleGptSearchClick = () =>{
       dispatch(toggleGptSerchView());
       dispatch(addGptMovieResult({movieNames:null, moviesResult:null}));
  }

  const handleLanguageChange = (e) =>{
       dispatch(changelanguage(e.target.value));  
  }


  return (
    <div className="absolute px-5 py-2 bg-gradient-to-b w-full from-black z-20 flex  flex-col align-item items-center m-auto  md:flex-row justify-between">
      <img className="w-44 m-auto md:m-0" src={logo} alt="Logo" />
      {user && (
        <div className="m-auto flex justify-between md:flex p-2 gap-2 md:m-0">
        {showGptSearch && !showDetails &&  <select className="px-4 py-2 m-2 bg-gray-500 text-white" onChange={handleLanguageChange} >
            {SUPPORTED_LANG.map(lang =>
              <option key={lang.identifier} value={lang.identifier}>{lang.name}</option>)}
          </select>}
         {!showDetails && <button onClick={handleGptSearchClick} type="button" class="text-white bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 hover:bg-gradient-to-br focus:outline-none  font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
          {!showGptSearch ? 'GPT-Search' : 'Home ' }  </button>}
         
          <button
            onClick={handleSignOut}
            type="button"
            class="text-white bg-gradient-to-r py-3 from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm px-5  text-center me-2 mb-2">
              Sign-out
          </button>
          <img className="hidden  md:inline-block w-10 h-10 rounded-xl" alt='user-img' src={usImg} />
          <p className="text-white p-2 font-bold text-base ">{user.displayName}</p>
        </div>
      )}
    </div>
  );
};

export default Header;
